import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  IconButton,
  Button,
  Stack,
  Input,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import JBWDateLabel from './JBWDateLabel';
const AgreementInfo = ({
  agreement,
  fulldetail = true,
  showAgreementTable,
  // "potential": a Potential Agreement (#418) with no tblAgreement row yet, so the name, contact
  // and location edits -- which save against agreement.id -- are hidden until it exists.
  formType = "confirm",
  onAgreementInfoUpdate,
  isEmPhUpdated,
  isNameUpdated,
  isAddressUpdated,
  onEnableCustomerNameEdit,
  onEnablePhoneEmailEdit,
  onEnableLocationEdit,
  onSearchLocationClick
}) => {

  console.log("Agreement Info component - agreement data:", agreement);
  // "confirm" and "potential" show customer details read-only; "edit" and "duplicate" can change them.
  const canEditCustomerDetails = formType !== "confirm" && formType !== "potential";
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [addressLine1, setAddressLine1] = useState(null);
  const [addressLine2, setAddressLine2] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [zipCode, setZipCode] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);

  useEffect(() => {
    if (agreement.emailAddress !== null) {
      setEmailAddress(agreement.emailAddress);
    }
    if (agreement.phoneNumber !== null) {
      setPhoneNumber(agreement.phoneNumber);
    }
  }, [agreement.emailAddress, agreement.phoneNumber]);

  useEffect(() => {
    if (agreement.addressLine1 !== null) {
      setAddressLine1(agreement.addressLine1);
    }
    if (agreement.addressLine2 !== null) {
      setAddressLine2(agreement.addressLine2);
    }
    if (agreement.city !== null) {
      setCity(agreement.city);
    }
    if (agreement.state !== null) {
      setState(agreement.state);
    }
    if (agreement.zipcode !== null) {
      setZipCode(agreement.zipcode);
    }
  }, [
    agreement.addressLine1,
    agreement.addressLine2,
    agreement.city,
    agreement.state,
    agreement.zipcode,
  ]);

  useEffect(() => {
    if (agreement.firstName !== null) {
      setFirstName(agreement.firstName);
    }
    if (agreement.lastName !== null) {
      setLastName(agreement.lastName);
    }
  }, [agreement.firstName, agreement.lastName]);

  const handleUpdateInfo = (event, type) => {
    event.stopPropagation();
    if (type === "name") {
      const info = { infoType: "name", firstName, lastName };
      onAgreementInfoUpdate(agreement.id, emptyToNull(info));
      // setCustomerNameEdit(false);
    } else if (type === "emph") {
      const info = { infoType: "emph", emailAddress, phoneNumber };
      onAgreementInfoUpdate(agreement.id, emptyToNull(info));
      // setPhoneEmailEdit(false);
    } else if (type === "address") {
      const info = {
        infoType: "address",
        addressLine1,
        addressLine2,
        city,
        state,
        zipcode: zipCode,
      };
      onAgreementInfoUpdate(agreement.id, emptyToNull(info));
      // setLocationEdit(false);
    }

  };

  function emptyToNull(obj) {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k, v === '' ? null : v])
    );
  }

  return (
    <>
      {fulldetail ? (
        <TableContainer>
          <Box>
            {showAgreementTable && agreement.jbwAgreementId && (
              <Table
                sx={{ minWidth: 550, mb: 4 }}
                size="small"
                aria-label="JBW Agreements table"
              >
                <TableHead sx={{ fontSize: "10px" }}>
                  <TableRow>
                    <TableCell align="left">Agreement Id</TableCell>
                    <TableCell align="left">Pdf</TableCell>
                    <TableCell align="left">Warranty Start Date</TableCell>
                    <TableCell align="left">Warranty End Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    key={agreement.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {agreement.jbwAgreementId || "N/A"}
                    </TableCell>
                    <TableCell align="left">
                      {agreement.pdfURL || "N/A"}
                    </TableCell>
                    <TableCell align="left">
                      {agreement.warrantyStartDate ? (
                        <JBWDateLabel
                          inputDate={agreement.warrantyStartDate}
                          dateFormat="MM/DD/YYYY"
                        />
                      ) : (
                        "N/A"
                      )}
                    </TableCell>

                    <TableCell align="left">
                      {agreement.warrantyEndDate ? (
                        <JBWDateLabel
                          inputDate={agreement.warrantyEndDate}
                          dateFormat="MM/DD/YYYY"
                        />
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            )}
            {/* </Box> */}
            {/* <Box> */}
            <Table
              sx={{ minWidth: 550 }}
              size="small"
              aria-label="JBW Agreements table"
            >
              <TableHead sx={{ fontSize: "10px" }}>
                <TableRow>
                  <TableCell>Dealer Id</TableCell>
                  <TableCell align="left">Tenant Id</TableCell>
                  {/* <TableCell align="left">Invoice Number</TableCell>*/}
                  <TableCell align="left">Job Number</TableCell>
                  <TableCell align="left">Product Code</TableCell>
                  <TableCell align="left">Customer Name</TableCell>
                  <TableCell align="left">Phone & Email</TableCell>
                  <TableCell align="left">Location ID</TableCell>
                  <TableCell align="left">Address</TableCell>
                  {/* <TableCell align="left">Purchase Date</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  key={agreement.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {agreement.dealerId}
                  </TableCell>
                  <TableCell align="left">{agreement.tenantId}</TableCell>
                  {/*  <TableCell align="left">
                    {agreement.poNumber ? agreement.poNumber : agreement.invoiceId}
                  </TableCell> */}
                  <TableCell align="left">{agreement.jobNumber}</TableCell>
                  <TableCell align="left">{agreement.productCode}</TableCell>
                  <TableCell align="left">
                    {isNameUpdated ? (
                      <>
                        <stack direction="row">
                          <Input
                            value={firstName !== null ? firstName : ""}
                            name="firstName"
                            placeholder="First Name"
                            onChange={(e) => {
                              setFirstName(e.target.value);
                            }}
                          />
                          <br />
                          <Input
                            value={lastName !== null ? lastName : ""}
                            name="lastName"
                            placeholder="Last Name"
                            onChange={(e) => {
                              setLastName(e.target.value);
                            }}
                          />
                        </stack>
                        <br />
                        <Box
                          display="flex"
                          justifyContent="flex-end"
                          sx={{ mr: 4 }}
                        >
                          <stack direction="column">
                            <IconButton
                              sx={{ alignSelf: "center" }}
                              size="small"
                              color="success"
                              onClick={(event) => { handleUpdateInfo(event, "name") }}
                            >
                              <DoneIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              sx={{ alignSelf: "center" }}
                              size="small"
                              color="warning"
                              onClick={(event) => {
                                event.stopPropagation();
                                onEnableCustomerNameEdit(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          </stack>
                        </Box>
                      </>
                    ) : (
                      <Stack direction="row">
                        <Typography
                          variant="subtitl1"
                          component="span"
                          sx={{
                            wordWrap: "break-word",
                          }}
                          whiteSpace="normal"
                        >
                          {agreement.customerName}
                        </Typography>
                        {canEditCustomerDetails && (
                          <IconButton
                            sx={{ alignSelf: "center" }}
                            size="small"
                            color="primary"
                            onClick={(event) => {
                              event.stopPropagation();
                              onEnableCustomerNameEdit(true);
                            }}
                          >
                            <EditIcon fontSize="inherit" />
                          </IconButton>
                        )}
                      </Stack>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {isEmPhUpdated ? (
                      <>
                        <stack direction="row">
                          <Input
                            value={phoneNumber !== "null" ? phoneNumber : ""}
                            name="phoneNumber"
                            placeholder="Phone Number"
                            onChange={(e) => {
                              setPhoneNumber(e.target.value);
                            }}
                          />
                          <br />
                          <Input
                            value={emailAddress !== "null" ? emailAddress : ""}
                            name="emailAddress"
                            placeholder="Email Address"
                            onChange={(e) => {
                              setEmailAddress(e.target.value);
                            }}
                          />
                        </stack>
                        <br />
                        <Box
                          display="flex"
                          justifyContent="flex-end"
                          sx={{ mr: 4 }}
                        >
                          <stack direction="column">
                            <IconButton
                              sx={{ alignSelf: "center" }}
                              size="small"
                              color="success"
                              onClick={(event) => { handleUpdateInfo(event, "emph") }}
                            >
                              <DoneIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              sx={{ alignSelf: "center" }}
                              size="small"
                              color="warning"
                              onClick={(event) => {
                                event.stopPropagation();
                                onEnablePhoneEmailEdit(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          </stack>
                        </Box>
                      </>
                    ) : (
                      <Stack direction="row">
                        <Typography
                          variant="subtitl1"
                          component="span"
                          sx={{
                            wordWrap: "break-word",
                          }}
                          whiteSpace="normal"
                        >
                          {(agreement.phoneNumber !== null && agreement.phoneNumber !== "null") ? agreement.phoneNumber : ""}
                        </Typography>
                        <br />
                        <Typography
                          variant="subtitl1"
                          component="span"
                          sx={{
                            wordWrap: "break-word",
                          }}
                          whiteSpace="normal"
                        >
                          {(agreement.emailAddress !== null && agreement.emailAddress !== "null") ? ", " + agreement.emailAddress : ""}
                        </Typography>
                        {canEditCustomerDetails && (
                          <IconButton
                            sx={{ alignSelf: "center" }}
                            size="small"
                            color="primary"
                            onClick={(event) => {
                              event.stopPropagation();
                              onEnablePhoneEmailEdit(true);
                            }}
                          >
                            <EditIcon fontSize="inherit" />
                          </IconButton>
                        )}
                      </Stack>
                    )}
                  </TableCell>
                  <TableCell align="left">

                    {agreement.locationId ? (
                      agreement.locationId
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{
                            borderRadius: "20px",
                            fontSize: "11px",
                            px: 1.0,
                            py: 0.3,
                            minWidth: "auto"
                          }}
                          onClick={onSearchLocationClick}
                        >
                          Search ST
                        </Button>
                      </>
                    )}

                  </TableCell>
                  <TableCell align="left">
                    {isAddressUpdated ? (
                      <>
                        <stack direction="row">
                          <Input
                            value={addressLine1 !== "null" ? addressLine1 : ""}
                            name="addressLine1"
                            placeholder="AddressLine 1"
                            onChange={(e) => {
                              setAddressLine1(e.target.value);
                            }}
                          />
                          <br />
                          <Input
                            value={addressLine2 !== "null" ? addressLine2 : ""}
                            name="addressLine2"
                            placeholder="AddressLine 2"
                            onChange={(e) => {
                              setAddressLine2(e.target.value);
                            }}
                          />
                          <br />
                          <Input
                            value={city !== "null" ? city : ""}
                            name="city"
                            placeholder="City"
                            onChange={(e) => {
                              setCity(e.target.value);
                            }}
                          />
                          <br />
                          <Input
                            value={state !== "null" ? state : ""}
                            name="state"
                            placeholder="State"
                            onChange={(e) => {
                              setState(e.target.value);
                            }}
                          />
                          <br />
                          <Input
                            value={zipCode !== "null" ? zipCode : ""}
                            name="zipCode"
                            placeholder="ZipCode"
                            onChange={(e) => {
                              setZipCode(e.target.value);
                            }}
                          />
                        </stack>
                        <br />
                        <Box
                          display="flex"
                          justifyContent="flex-end"
                          sx={{ mr: 4 }}
                        >
                          <stack direction="column">
                            <IconButton
                              sx={{ alignSelf: "center" }}
                              size="small"
                              color="success"
                              onClick={(event) => { handleUpdateInfo(event, "address") }}
                            >
                              <DoneIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              sx={{ alignSelf: "center" }}
                              size="small"
                              color="warning"
                              onClick={(event) => {
                                event.stopPropagation();
                                onEnableLocationEdit(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          </stack>
                        </Box>
                      </>
                    ) : (
                      <Stack direction="row">
                        <Typography
                          variant="subtitl1"
                          component="span"
                          sx={{
                            wordWrap: "break-word",
                          }}
                          whiteSpace="normal"
                        >
                          {agreement.location}.
                        </Typography>
                        {canEditCustomerDetails && (
                          <IconButton
                            sx={{ alignSelf: "center" }}
                            size="small"
                            color="primary"
                            onClick={(event) => {
                              event.stopPropagation();
                              onEnableLocationEdit(true);
                            }}
                          >
                            <EditIcon fontSize="inherit" />
                          </IconButton>
                        )}
                      </Stack>
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            {(formType === "confirm" || formType === "duplicate") && (
              <Grid item xs={8} align="right">
                <Typography
                  variant="captiondo"
                  component="subtitle1"
                  align="left"
                  sx={{ fontSize: "14px" }}
                >
                  Plan Description :
                </Typography>
                <Typography
                  variant="caption"
                  component="subtitle1"
                  align="left"
                  sx={{ fontSize: "14px" }}
                >
                  {agreement.productDescription}
                </Typography>
                <>
                  {"  "}
                  <Typography
                    variant="captiondo"
                    component="subtitle1"
                    align="left"
                    sx={{ fontSize: "14px" }}
                  >
                    Allowed Equipment :
                  </Typography>
                  <Typography
                    variant="caption"
                    component="subtitle1"
                    align="left"
                    sx={{ fontSize: "14px" }}
                  >
                    {agreement.equipmentUnits}
                  </Typography>
                </>
              </Grid>
            )}
          </Box>
        </TableContainer>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={2}>
            <Typography>
              <b>Job ID:</b> {agreement.jobNumber}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>
              <b>Invoice ID:</b> {agreement.invoiceId}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>
              <b>Customer Name:</b> {agreement.customer}
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography>
              <b>Address:</b>
              {agreement.address ? agreement.address : ""}.
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AgreementInfo;
